import { create } from 'zustand';

import { createPanelSlice, type PanelSlice } from '~/components/v2/store/shared/createPanelSlice';

export type WorkspaceNotificationsState = PanelSlice;

export const useWorkspaceNotificationsStore = create<WorkspaceNotificationsState>()((...args) => ({
  ...createPanelSlice({ open: false })(...args),
}));
